import { room } from "../../libs/roomnew";

export function getLayers(){
    try {
        let videoSender=room.getActivePeerConnection().peerconnection.getSenders().find(sender=>sender.track && sender.track.kind === "video");
        if(videoSender){
            let params=videoSender.getParameters();
            console.log("Sender parameters",params);
        }else{
            console.log("no video sender found");
        }

    } catch (error) {
            console.error("Error getting video sender",error);
    }
};

export function disableSimlucastLayers(layers=[]){
    try {
        let videoSender=room.getActivePeerConnection().peerconnection.getSenders().find(sender=>sender.track && sender.track.kind === "video");
        if(videoSender){
            let params=videoSender.getParameters();
            layers.forEach(idx=>{
                if(params.encodings[idx]){
                    params.encodings[idx].active = false;
                }
            });
            videoSender.setParameters(params);
            console.log("Setting simulcast layers",params.encodings);
        }else{
            console.log("no video sender found");
        }

    } catch (error) {
            console.error("Error getting video sender",error);
    }
};

export function enableSimulcastLayers(){
    try {
        let videoSender=room.getActivePeerConnection().peerconnection.getSenders().find(sender=>sender.track && sender.track.kind === "video");
        if(videoSender){
            let params=videoSender.getParameters();
            params.encodings.forEach(layer=>{
                layer.active=true;
            });
            videoSender.setParameters(params);
            console.log("Setting simulcast layers",params.encodings);
        }else{
            console.log("no video sender found");
        }

    } catch (error) {
            console.error("Error getting video sender",error);
    }
}